import React, { Component } from 'react';
import Loading from '../../Loading.js'
import ControlProjects from './ControlProjects.js';
import { getCandidateProjects } from '../../../Api/ExtranetActions.js';

declare var globalSns;

class ExtranetCandidatesProjects extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getCandidateProjects(this.props.id, globalSns.languageId, (data) => {
            this.setState({
                candidateProjects: data
            });
        });
    }

    render() {
        if (this.state.candidateProjects == null) {
            return (
                <Loading/>
            );
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <ControlProjects projects={this.state.candidateProjects} 
                        onNavigateToProject={(row) => this.props.onNavigate("extranetProjectsFiche", row.id, row.title)}
                        onNavigateToDocuments={(row) => this.props.onSubNavigate("extranetCandidatesDocuments")}
                        onNavigateToMessages={(row) => this.props.onSubNavigate("extranetCandidatesMessages")}
                    />
                </div>                
            </div>
        );
    }
}

export default ExtranetCandidatesProjects;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetCandidatesProjects.js